<template>
  <div
    class="manager_box"
    style="background:white;min-height:80vh; padding:20px;"
    v-loading="loading"
  >
    <div class="attendance">
      <div class="screen_div">
        <!-- <el-select v-model="personnel_value" placeholder="筛选人" style='margin-right:20px;' @change='personnel_value_change'>
                    <el-option key="" label="不限" value="" placeholder="不限"> </el-option>
                    <el-option v-for="item in personnel" :key="item.staff_id" :label="item.realname" :value="item.realname"> </el-option>
        </el-select>-->
        <el-input placeholder="请输入内容" v-model="input1" style="margin-right:20px;width:250px;">
          <template slot="prepend">筛选人</template>
        </el-input>
        <el-date-picker
          v-model="screening_month"
          type="month"
          placeholder="筛选月"
          value-format="yyyy-M"
          @change="screening_month_change"
          :clearable="false"
          style="margin-right:20px;width:250px;"
        ></el-date-picker>
        <el-button @click="screen_button">筛 选</el-button>
      </div>
      <el-button @click="add_attendance">添加考勤</el-button>
    </div>
    <el-table :data="tableData" style="width: 100%" v-loading="tableData_loading">
      <el-table-column prop="staff_name" label="姓名" min-width="80">
        <template slot-scope="scope">
          <el-popover placement="bottom-start" width="1100" trigger="click">
            <el-table :data="scope.row.children">
              <el-table-column prop="discipline_type_name" label="请假类型" min-width="80"></el-table-column>
              <el-table-column prop="leave_reason" label="请假原因" min-width="80"></el-table-column>
              <el-table-column prop="leave_time_total" label="请假时间(天)" min-width="110"></el-table-column>
              <el-table-column prop="leave_time_hour_total" label="请假时间(小时)" min-width="110"></el-table-column>
              <el-table-column prop="leave_start_time_str" label="开始时间" min-width="150"></el-table-column>
              <el-table-column prop="leave_end_time_str" label="结束时间" min-width="150"></el-table-column>
              <el-table-column prop="leave_time" label="时间备注" min-width="150"></el-table-column>
              <el-table-column label="操作" width="180">
                <template slot-scope="table_scope">
                  <div style="height:30px;line-height:30px">
                    <el-button @click="modify_tableData(table_scope.row, 0)" type="primary">修改</el-button>
                    <el-button @click="modify_tableData(table_scope.row, 1)" type="danger">删除</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div slot="reference" style="color:#409EFF; cursor: pointer;">{{scope.row.staff_name}}</div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="discipline_type_name" label="请假类型" min-width="80"></el-table-column>

      <el-table-column prop="leave_counts" label="当月迟到次数" min-width="80"></el-table-column>
      <el-table-column prop="leave_early_counts" label="当月早退次数" min-width="80"></el-table-column>
      <el-table-column prop="total_leave" label="总请假时间" min-width="110"></el-table-column>
      <el-table-column prop="leave_reason" label="请假原因" min-width="80"></el-table-column>

      <el-table-column prop="leave_start_time_str" label="开始时间" min-width="150"></el-table-column>
      <el-table-column prop="leave_end_time_str" label="结束时间" min-width="150"></el-table-column>
      <el-table-column prop="leave_time" label="时间备注" min-width="150"></el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <div>
            <el-button @click="modify_tableData(scope.row, 0)" type="primary">修改</el-button>
            <el-button @click="modify_tableData(scope.row, 1)" type="danger">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="提示" :visible.sync="dialogVisible" class="el_table_class">
      <el-form
        :label-position="labelPosition"
        label-width="80px"
        :model="formLabelAlign"
        style="max-height:60vh;overflow: auto;"
      >
        <el-form-item :required="true" label="名字">
          <el-input v-model="formLabelAlign.staff_name" class="el_input" placeholder="请填写姓名"></el-input>
        </el-form-item>
        <el-form-item :required="true" label="请假类型">
          <el-cascader
            :options="options"
            v-model="options_value"
            class="el_input"
            placeholder="请填写原因"
          ></el-cascader>
        </el-form-item>
        <el-form-item
          v-if="options_value=='4'|| options_value[0] =='3'"
          :required="true"
          label="请假时间"
        >
          <el-date-picker
            v-model="datetimerange_value"
            :default-time="['09:00:00', '18:00:00']"
            value-format="timestamp"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width:80%;min-width: 300px;"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="时间备注">
          <el-input v-model="formLabelAlign.leave_time" class="el_input" placeholder="请填写天数备注"></el-input>
        </el-form-item>
        <el-form-item :required="true" label="请假原因">
          <el-input
            type="textarea"
            v-model="formLabelAlign.leave_reason"
            class="el_input"
            placeholder="请填写请假理由"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="determine"
        >{{formLabelAlign.label_code == 'create' ? '确 定' : '修改'}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { require } from '@/utils/http_request.js'

export default {
  data() {
    return {
      loading: false,
      tableData_loading: false,
      dialogVisible: false,

      month_list: [],
      tableData: [],
      options: [
        // 迟到原因
        { value: '1', label: '迟到' },
        { value: '2', label: '早退' },
        {
          value: '3',
          label: '请假',
          children: [
            { value: '1', label: '事假' },
            { value: '2', label: '病假' },
          ],
        },
        { value: '4', label: '旷工' },
      ],
      options_value: [], // 迟到原因——id
      datetimerange_value: [], // 时间

      labelPosition: 'right',
      formLabelAlign: {
        label_code: '',
        staff_name: '',
        leave_start_time: '',
        leave_end_time: '',
        discipline_type: '',
        leave_time: '',
        leave_reason: '',
      },
      attendance_id: '',

      personnel: [], // 筛选人
      input1: '',
      personnel_value: '', // 筛选人
      screening_month: '', // 筛选月
      year_value: '',
      month_value: '',
    }
  },
  created() {
    this.screening_month =
      new Date().getFullYear() + '-' + (new Date().getMonth() + 1)
    this.year_value = new Date().getFullYear()
    this.month_value = new Date().getMonth() + 1
    console.log(this.screening_month, this.month_value)
    this.attendance_management_list()
    this.all_user_info()
  },
  methods: {
    attendance_management_list() {
      // 考勤列表
      this.tableData_loading = true
      let search_data = {}
      if (this.year != '') {
        search_data.year = this.year_value
        search_data.month = this.month_value
      }
      if (this.input1 != '') {
        search_data.staff_name = this.input1
      }
      require('post', '/lufish_hrm/v1/attendance_management_list/', {
        search_data,
      }).then((res) => {
        console.log(res)
        if (!res.code) {
          this.tableData = res.data
        }
        this.tableData_loading = false
      })
    },
    all_user_info() {
      // 员工列表
      require('post', '/lufish_user/v1/all_user_info/', {}).then((res) => {
        console.log(res)
        if (!res.code) {
          this.personnel = res.data
        }
      })
    },
    add_attendance() {
      // 创建考勤
      this.datetimerange_value = []
      this.options_value = []
      this.formLabelAlign = {
        label_code: 'create',
        staff_name: '',
        leave_start_time: '',
        leave_end_time: '',
        discipline_type: '',
        leave_time: '',
        leave_reason: '',
      }
      this.dialogVisible = true
      console.log('添加考情状况')
    },
    determine() {
      console.log('时间戳', this.datetimerange_value, this.options_value)
      if (this.datetimerange_value.length > 0) {
        this.formLabelAlign.leave_start_time =
          this.datetimerange_value[0] / 1000
        this.formLabelAlign.leave_end_time = this.datetimerange_value[1] / 1000
      }
      if (this.options_value.length == 2) {
        this.formLabelAlign.discipline_type = this.options_value[0]
        this.formLabelAlign.leave_type = this.options_value[1]
      } else if (this.options_value.length == 1) {
        this.formLabelAlign.discipline_type = this.options_value[0]
        this.formLabelAlign.leave_type = 0
      }

      if (
        this.formLabelAlign.discipline_type == '1' ||
        this.formLabelAlign.discipline_type == '2'
      ) {
        for (let i in this.formLabelAlign) {
          if (
            this.formLabelAlign[i] === '' &&
            i != 'leave_time' &&
            i != 'leave_start_time' &&
            i != 'leave_end_time'
          ) {
            console.log('参数', this.formLabelAlign)
            this.$message.error('请将信息填写完整')
            return false
            break
          }
        }
      } else {
        for (let i in this.formLabelAlign) {
          if (this.formLabelAlign[i] === '' && i != 'leave_time') {
            console.log('参数', this.formLabelAlign)
            this.$message.error('请将信息填写完整')
            return false
            break
          }
        }
      }

      if (this.formLabelAlign.label_code == 'create') {
        if (
          this.formLabelAlign.discipline_type == '1' ||
          this.formLabelAlign.discipline_type == '2'
        ) {
          require('post', '/lufish_hrm/v1/ask_for_leave/', {
            label_code: 'create',
            staff_name: this.formLabelAlign.staff_name,
            leave_reason: this.formLabelAlign.leave_reason,
            discipline_type: this.formLabelAlign.discipline_type,
          }).then((res) => {
            if (!res.code) {
              this.$message({ message: res.msg, type: 'success' })
              this.attendance_management_list()
              this.dialogVisible = false
            } else {
              this.$message.error(res.msg)
            }
          })
          return false
        }

        require('post', '/lufish_hrm/v1/deregulation_staff/', this
          .formLabelAlign).then((res) => {
          if (!res.code) {
            this.$message({ message: res.msg, type: 'success' })
            this.attendance_management_list()
            this.dialogVisible = false
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        if (
          this.formLabelAlign.discipline_type == '1' ||
          this.formLabelAlign.discipline_type == '2'
        ) {
          require('post', '/lufish_hrm/v1/ask_for_leave/', {
            label_code: 'update',
            attendance_id: this.attendance_id,
            update_data: {
              discipline_type: this.formLabelAlign.discipline_type,
              leave_reason: this.formLabelAlign.leave_reason,
            },
          }).then((res) => {
            if (!res.code) {
              this.$message({ message: res.msg, type: 'success' })
              this.attendance_management_list()
              this.dialogVisible = false
            } else {
              this.$message.error(res.msg)
            }
          })
          return false
        }
        require('post', '/lufish_hrm/v1/deregulation_staff/', {
          label_code: 'update',
          attendance_id: this.attendance_id,
          update_data: {
            discipline_type: this.formLabelAlign.discipline_type,
            leave_type: this.formLabelAlign.leave_type,
            leave_start_time: this.formLabelAlign.leave_start_time,
            leave_end_time: this.formLabelAlign.leave_end_time,
            leave_time: this.formLabelAlign.leave_time,
            leave_reason: this.formLabelAlign.leave_reason,
            staff_name: this.formLabelAlign.staff_name,
          },
        }).then((res) => {
          if (!res.code) {
            this.$message({ message: res.msg, type: 'success' })
            this.attendance_management_list()
            this.dialogVisible = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    modify_tableData(row, id) {
      console.log(row, row.discipline_type)
      if (!id) {
        if (row.leave_type > 0) {
          this.options_value = [
            String(row.discipline_type),
            String(row.leave_type),
          ]
        } else {
          this.options_value = [String(row.discipline_type)]
        }
        console.log('修改', this.options_value, row)
        this.datetimerange_value = [
          String(row.leave_start_time * 1000),
          String(row.leave_end_time * 1000),
        ]
        this.attendance_id = row.attendance_id
        this.formLabelAlign.label_code = 'update'
        this.formLabelAlign.staff_name = row.staff_name
        this.formLabelAlign.leave_time = row.leave_time
        this.formLabelAlign.leave_reason = row.leave_reason

        this.dialogVisible = true
      } else {
        this.$confirm('确定删除此次考勤吗', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            require('post', '/lufish_hrm/v1/deregulation_staff/', {
              label_code: 'delete',
              attendance_id: row.attendance_id,
            }).then((res) => {
              console.log(res)
              if (!res.code) {
                this.$message({ type: 'success', message: res.msg })
                this.attendance_management_list()
              }
            })
          })
          .catch(() => {})
      }
    },
    // personnel_value_change(e) {
    //     console.log(e)
    //     // this.attendance_management_list()
    // },
    screening_month_change(e) {
      console.log(e)
      let add = e.split('-')
      this.year_value = add[0]
      this.month_value = add[1]
    },
    screen_button() {
      this.attendance_management_list()
    },
  },
  watch: {
    datetimerange_value: function (new_value, old_value) {
      // 防止datetimerange_value为null
      if (new_value == null) {
        this.datetimerange_value = []
      }
    },
  },
}
</script>

<style>
.attendance {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px #ccc solid;
}
.screen_div {
  flex: 1;
  display: flex;
  align-items: center;
}
.el_input {
  width: 80%;
}
.attendance >>> .el-table .cell {
  height: 44px;
  line-height: 44px;
}
</style>


// WEBPACK FOOTER //
// src/personnel_matters/check_work_attendance.vue